import { render, staticRenderFns } from "./tag-group.vue?vue&type=template&id=89f1d4f8&scoped=true"
import script from "./tag-group.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tag-group.vue?vue&type=style&index=0&id=89f1d4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f1d4f8",
  null
  
)

export default component.exports